<div class="footer-holder">
    <div class="container">
    <div class="row">
        <div class="col-md-6 footer">
          &copy; 2022  Boldungu - learn by doing

            <br/>
            <img src="/assets/images/boldungu_logo.png" width="40"/>
            <app-get-it-from-google-play></app-get-it-from-google-play>


          <div>
              For support contact us on WhatsApp: +256 776 495 020
          </div>


        </div>
        <div class="col-md-2">
        <h6>Resources</h6>
        <ul class="list-group list-group-flush">
        <li class="list-group-item"><a [routerLink]="['/blog']">Blog</a> </li>
        <li class="list-group-item"><a [routerLink]="['/static/display/faq']">FAQ</a></li>
        <li class="list-group-item"><a href="#">Complaint Form</a> </li>
        </ul>
        </div>


        <div class="col-md-2">
        <h6>Company</h6>
        <ul class="list-group list-group-flush">
        <li class="list-group-item"><a [routerLink]="['/static/display/about/us']">About Us</a> </li>
        <li class="list-group-item"><a href="#">Stories</a></li>
        <li class="list-group-item"><a href="#">Careers</a></li>
        </ul>

        </div>
        <div class="col-md-2">
        <h6>Policy</h6>
        <ul class="list-group list-group-flush">
        <li class="list-group-item"><a [routerLink]="['/info/privacy/policy']">Privacy Policy</a> </li>
         <li class="list-group-item"><a [routerLink]="['/info/policy/cookie']">Cookie Policy</a> </li>
        <li class="list-group-item"><a [routerLink]="['/info/usage/policy']">Terms & Conditions</a></li>
        </ul>
        </div>
      </div>
    </div>
    </div>
